import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Solutions from "./components/Solutions";
import About from "./components/About";
import MentorAndTeam from "./pages/MentorAndTeam";
//import GlobalPresence from "./components/GlobalPresence";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Careers from "./pages/careers";
import Products from "./pages/OurProducts";

function App() {
  return (
    <Router>
      <div className="font-sans bg-slate-950 min-h-screen flex flex-col">
        <Navbar />

        <main className="flex-grow">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Hero />
                    <Solutions />
                  <About />
                 <MentorAndTeam />
                  {/* <GlobalPresence /> */}
                  <Contact />
                </>
              }
            />

            <Route path="/careers" element={<Careers />} />
            <Route path="/products" element={<Products />} />
            <Route path="/mentor-team" element={<MentorAndTeam />} />

          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
